<ng-container *transloco="let t">
  <ng-container *ngIf="!printPreview; then editTpl; else printPreviewTpl">
  </ng-container>

  <ng-template #editTpl>
    <nz-page-header
      class="page-details header"
      [nzBackIcon]="backBtnTemplate"
      *ngIf="entity"
    >
      <nz-page-header-title data-testid="page-title">{{
        title
      }}</nz-page-header-title>
      <nz-page-header-extra>
        <authority-labs-files-storage
          [folderId]="entity?.order?.sharePoint?.plans"
          [subFolders]="subFolders"
          [entity]="uploadEntity"
        ></authority-labs-files-storage>
        <nz-space>
          <ng-template nzSpaceItem>
            <ng-container *ngIf="!readonly && !dataChanged">
              <button
                nz-button
                nzGhost
                nzType="primary"
                type="button"
                (click)="initInspection()"
              >
                {{ t('inspection.actions.resetData') }}
              </button>
            </ng-container>
          </ng-template>

          <ng-template nzSpaceItem>
            <ng-container *ngIf="!readonly && !dataChanged">
              <button
                nz-button
                nz-dropdown
                nzGhost
                nzType="primary"
                [nzDropdownMenu]="menu"
              >
                <i nz-icon nzType="snippets"></i>
                {{ t('inspection.actions.pullData') }}
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="extendInspection()">
                    {{ t('inspection.actions.pullFromOrders') }}
                  </li>
                  <li nz-menu-item (click)="extendInspectionFromTemplate()">
                    {{ t('inspection.actions.pullFromTemplate') }}
                  </li>
                </ul>
              </nz-dropdown-menu>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem>
            <ng-container *ngIf="!dataChanged">
              <button
                nz-button
                nzGhost
                nzType="primary"
                type="button"
                (click)="saveAsTemplate()"
              >
                {{ t('inspection.actions.saveAsTemplate') }}
              </button>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem>
            <ng-container *ngIf="dataChanged">
              <button
                nz-button
                nzGhost
                nzType="primary"
                type="button"
                data-testid="inspection-cancel"
                (click)="cancel()"
              >
                ביטול
              </button>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem>
            <ng-container *ngIf="!readonly && dataChanged">
              <button
                nz-button
                nzType="primary"
                type="submit"
                data-testid="inspection-save"
                [nzLoading]="submitting"
                [disabled]="submitting"
                (click)="save()"
              >
                שמירה
              </button>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem>
            <ng-container *ngIf="!dataChanged">
              <button
                nz-button
                nzGhost
                nzType="primary"
                type="button"
                data-testid="inspection-certificate"
                (click)="openCertificateDialog()"
              >
                {{ t('inspection.actions.certificate') }}
              </button>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem>
            <ng-container *ngIf="!dataChanged">
              <button
                nz-button
                nzGhost
                nzType="primary"
                type="button"
                (click)="openDraft()"
              >
                <i nz-icon nzType="highlight" nzTheme="outline"></i>
                {{ t('inspection.actions.draft') }}
              </button>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem>
            <ng-container
              *ngIf="!readonly && !dataChanged && draftStatus === 'closed'"
            >
              <button
                nz-button
                nzGhost
                nzType="primary"
                type="button"
                (click)="importFromDraft()"
              >
                <i nz-icon nzType="import" nzTheme="outline"></i>
                {{ t('inspection.actions.importFromDraft') }}
              </button>
            </ng-container>
          </ng-template>
          <ng-template nzSpaceItem></ng-template>
        </nz-space>
        <button
          mat-icon-button
          (click)="inspectionPrintPreview()"
          *ngIf="!dataChanged"
        >
          <span nz-icon nzType="printer" nzTheme="fill"></span>
        </button>
        <button
          mat-icon-button
          (click)="toggleDrawer()"
          style="margin: 0"
          *ngIf="navbarLinks?.length > 0"
        >
          <mat-icon>reorder</mat-icon>
        </button>
      </nz-page-header-extra>
      <nz-page-header-content>
        <main class="input">
          <mat-tab-group
            mat-stretch-tabs
            animationDuration="0ms"
            [(selectedIndex)]="selectedTabIndex"
            (selectedIndexChange)="selectedTabIndexChange($event)"
          >
            <mat-tab [label]="t('inspection.sections.general')">
              <section class="tab">
                <ng-container [ngTemplateOutlet]="generalTpl"></ng-container>
              </section>
            </mat-tab>

            <mat-tab *ngFor="let tab of tabItems">
              <ng-template mat-tab-label>
                <mat-icon
                  class="fail"
                  color="warn"
                  *ngIf="!entity[tab.inspectionKey].isPassed"
                >
                  priority_high
                </mat-icon>
                <span>{{ tab.title }}</span>
              </ng-template>
              <ng-template matTabContent>
                <mat-drawer-container>
                  <mat-drawer
                    [mode]="drawerMode"
                    [opened]="drawerOpened"
                    *ngIf="navbarLinks?.length > 0"
                  >
                    <authority-labs-navbar
                      [links]="navbarLinks"
                    ></authority-labs-navbar>
                  </mat-drawer>
                  <mat-drawer-content>
                    <section class="tab">
                      <ng-container
                        [ngTemplateOutlet]="tab.template"
                      ></ng-container>
                    </section>
                  </mat-drawer-content>
                </mat-drawer-container>
              </ng-template>
            </mat-tab>

            <mat-tab [label]="t('inspection.sections.summary')">
              <section class="tab">
                <ng-container [ngTemplateOutlet]="summeryTpl"></ng-container>
              </section>
            </mat-tab>
          </mat-tab-group>
        </main>
        <nz-upload
          [nzMultiple]="true"
          [nzShowUploadList]="false"
          [nzBeforeUpload]="beforeUpload"
          [nzAccept]="'image/*,.pdf'"
        >
          <button
            class="attach-image"
            mat-mini-fab
            color="accent"
            aria-label="add a photo"
          >
            <mat-icon>add_a_photo</mat-icon>
          </button>
        </nz-upload>
      </nz-page-header-content>
    </nz-page-header>
  </ng-template>

  <ng-template #printPreviewTpl>
    <div class="print-preview" *ngIf="entity">
      <h3>
        <strong>שם הפרוייקט: {{ entity.order?.subProject?.name }}</strong>
      </h3>
      <h3>
        <strong>הזמנה מס': {{ entity.orderId }}</strong>
      </h3>

      <main class="input">
        <ng-container [ngTemplateOutlet]="generalTpl"></ng-container>

        <ng-container
          *ngIf="entity.inspectionDesign"
          [ngTemplateOutlet]="inspectionDesignTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionInstallation"
          [ngTemplateOutlet]="inspectionInstallationTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionWaterNetworkCharacterization"
          [ngTemplateOutlet]="inspectionWaterNetworkCharacterizationTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionGasExtinguishingSystem"
          [ngTemplateOutlet]="inspectionGasExtinguishingSystemTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionFireTaps"
          [ngTemplateOutlet]="inspectionFireTapsTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionFireExtinguishers"
          [ngTemplateOutlet]="inspectionFireExtinguishersTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionAerosolShutdown"
          [ngTemplateOutlet]="inspectionAerosolShutdownTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionFireAlarmSystem"
          [ngTemplateOutlet]="inspectionFireAlarmSystemTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionAirConditioningAndVentilationSystems"
          [ngTemplateOutlet]="inspectionAirConditioningAndVentilationSystemsTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionVentilationSystemAndFireProtection"
          [ngTemplateOutlet]="inspectionVentilationSystemAndFireProtectionTpl"
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionPressureSystemInStairwellsCompatibilityCheck"
          [ngTemplateOutlet]="
            inspectionPressureSystemInStairwellsCompatibilityCheckTpl
          "
        ></ng-container>

        <ng-container
          *ngIf="entity.inspectionIntegration"
          [ngTemplateOutlet]="inspectionIntegrationTpl"
        ></ng-container>

        <ng-container [ngTemplateOutlet]="summeryTpl"></ng-container>
      </main>
    </div>
  </ng-template>

  <ng-template #backBtnTemplate>
    <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
  </ng-template>

  <ng-template #generalTpl>
    <div class="form" cdkScrollable>
      <br />
      <h3 class="main-title">{{ t('inspection.sections.general') }}</h3>
      <div class="list">
        <mat-form-field floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:inspectionDate')
          }}</mat-label>
          <input
            *ngIf="!(readonly || printPreview)"
            matInput
            class="text"
            name="inspectionDate"
            required
            [matDatepicker]="picker"
            [(ngModel)]="entity.inspectionDate"
            (click)="picker.open()"
            (dateInput)="onDataChange()"
            (dateChange)="onDataChange()"
          />
          <input
            *ngIf="readonly || printPreview"
            matInput
            class="text"
            name="inspectionDate"
            [ngModel]="entity.inspectionDate | date : 'mediumDate'"
            readonly
          />
          <mat-datepicker-toggle
            *ngIf="!(readonly || printPreview)"
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #picker></mat-datepicker>

        <mat-form-field class="fire-extinguishing-type" floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:representativeName')
          }}</mat-label>
          <input
            matInput
            name="representativeName"
            data-testid="field-representativeName"
            [(ngModel)]="entity.representativeName"
            [readonly]="readonly || printPreview"
            (input)="onDataChange()"
          />
          <authority-labs-draft-field-indicator
            matSuffix
            fieldId="general:representativeName"
            [inkFormData]="draftInkData"
          ></authority-labs-draft-field-indicator>
        </mat-form-field>

        <mat-form-field class="fire-extinguishing-type" floatLabel="always">
          <mat-label>{{
            t('inspection.fields.general:inspectionType')
          }}</mat-label>
          <mat-select
            *ngIf="!(readonly || printPreview)"
            [(ngModel)]="entity.inspectionType"
            (selectionChange)="onInspectionTypeChange($event)"
          >
            <mat-option
              *ngFor="let item of inspectionTypes | values"
              [value]="item"
            >
              {{ item }}
            </mat-option>
          </mat-select>

          <input
            *ngIf="readonly || printPreview"
            matInput
            class="text"
            name="inspectionType"
            [ngModel]="entity.inspectionType"
            readonly
          />
          <authority-labs-draft-field-indicator
            matSuffix
            fieldId="general:inspectionType"
          ></authority-labs-draft-field-indicator>
        </mat-form-field>

        <mat-form-field
          class="fire-extinguishing-type"
          floatLabel="always"
          *ngIf="entity.inspectionType && canShooseInspection"
        >
          <mat-label>{{
            t('inspection.fields.general:fireExtinguishingType')
          }}</mat-label>
          <mat-select
            *ngIf="!(readonly || printPreview)"
            [(ngModel)]="entity.fireExtinguishingType"
            (selectionChange)="onDataChange()"
          >
            <mat-option
              *ngFor="let item of fireExtinguishingType"
              [value]="item"
            >
              {{ item }}
            </mat-option>
          </mat-select>
          <input
            *ngIf="readonly || printPreview"
            matInput
            class="text"
            name="fireExtinguishingType"
            [ngModel]="entity.fireExtinguishingType"
            readonly
          />
        </mat-form-field>

        <mat-form-field
          class="standard"
          *ngIf="entity.inspectionType"
          floatLabel="always"
        >
          <mat-label>{{ t('inspection.fields.general:standard') }}</mat-label>
          <mat-select
            *ngIf="!(readonly || printPreview)"
            name="standard"
            [(ngModel)]="entity.standard"
            (selectionChange)="onDataChange()"
          >
            <mat-option value=""> </mat-option>
            <mat-option *ngFor="let item of standards" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
          <div matSuffix *ngIf="!(readonly || printPreview)">
            <button
              mat-icon-button
              aria-label="notes-bank"
              color="primary"
              (click)="
                showNotesBank(
                  $event,
                  inspectionTypeTextBankKey,
                  setStandard,
                  true
                )
              "
            >
              <mat-icon style="font-size: 20px">assignment</mat-icon>
            </button>
            <authority-labs-draft-field-indicator
              fieldId="general:standard"
            ></authority-labs-draft-field-indicator>
          </div>
          <input
            *ngIf="readonly || printPreview"
            matInput
            class="text"
            name="standard"
            [ngModel]="entity.standard"
            readonly
          />
        </mat-form-field>

        <mat-form-field
          class="standard"
          floatLabel="always"
          *ngIf="entity.inspectionType && entity.is1001"
        >
          <mat-label>{{
            t('inspection.fields.general:standardExtraText')
          }}</mat-label>
          <textarea
            matInput
            name="inspectionCount"
            [placeholder]="
              t('inspection.fields.general:standardExtraTextPlaceholder')
            "
            cdkTextareaAutosize
            [(ngModel)]="entity.standardExtraText"
            [readonly]="readonly || printPreview"
            (input)="onDataChange()"
          ></textarea>
          <div matSuffix class="note-btns" *ngIf="!(readonly || printPreview)">
            <button
              mat-icon-button
              aria-label="notes-bank"
              color="primary"
              (click)="
                showNotesBank(
                  $event,
                  entity.inspectionType + '_standardExtraText',
                  setStandardExtraText
                )
              "
            >
              <mat-icon style="font-size: 20px">assignment</mat-icon>
            </button>
            <authority-labs-draft-field-indicator
              fieldId="general:standardExtraText"
              [inkFormData]="draftInkData"
            ></authority-labs-draft-field-indicator>
          </div>
        </mat-form-field>

        <mat-form-field
          class="standard"
          floatLabel="always"
          *ngIf="
            entity.inspectionType &&
            !entity.isWaterNetworkCharacterizationInspection
          "
        >
          <mat-label>{{
            t('inspection.fields.general:inspectionCount')
          }}</mat-label>
          <textarea
            matInput
            name="inspectionCount"
            [placeholder]="
              t('inspection.fields.general:inspectionCountPlaceholder')
            "
            cdkTextareaAutosize
            [(ngModel)]="entity.inspectionCount"
            [readonly]="readonly || printPreview"
            (input)="onDataChange()"
          ></textarea>
          <div matSuffix class="note-btns" *ngIf="!(readonly || printPreview)">
            <button
              mat-icon-button
              aria-label="notes-bank"
              color="primary"
              (click)="
                showNotesBank(
                  $event,
                  entity.inspectionType + '_inspectionCount',
                  setInspectionCount
                )
              "
            >
              <mat-icon style="font-size: 20px">assignment</mat-icon>
            </button>
            <authority-labs-draft-field-indicator
              fieldId="general:inspectionCount"
              [inkFormData]="draftInkData"
            ></authority-labs-draft-field-indicator>
          </div>
        </mat-form-field>

        <div class="disclaimer">
          <h2>{{ t('inspection.sections.conflictOfInterest') }}</h2>
          <ul>
            <li>
              <label>{{
                t('inspection.fields.disclaimer:conflictQuestion')
              }}</label>
              <mat-radio-group
                [(ngModel)]="entity.disclaimer.isThereConflictOfInterest"
                [disabled]="readonly || printPreview"
                (change)="onDataChange()"
              >
                <mat-radio-button [value]="true" color="warn">{{
                  t('yes')
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  t('no')
                }}</mat-radio-button>
              </mat-radio-group>
            </li>
            <li>
              <label>{{
                t('inspection.fields.disclaimer:biasQuestion')
              }}</label>
              <mat-radio-group
                [(ngModel)]="entity.disclaimer.isThereReasonForBias"
                [disabled]="readonly || printPreview"
                (change)="onDataChange()"
              >
                <mat-radio-button [value]="true" color="warn">{{
                  t('yes')
                }}</mat-radio-button>
                <mat-radio-button [value]="false">{{
                  t('no')
                }}</mat-radio-button>
                <textarea
                  *ngIf="entity.disclaimer.isThereReasonForBias"
                  [(ngModel)]="entity.disclaimer.note"
                  nz-input
                  rows="4"
                  [placeholder]="t('inspection.fields.disclaimer:addNote')"
                  [readonly]="readonly || printPreview"
                  (input)="onDataChange()"
                ></textarea>
              </mat-radio-group>
            </li>
            <li>
              <p style="margin-bottom: 0">
                {{ t('inspection.fields.disclaimer:paragraph1') }}
              </p>
              <p>
                {{ t('inspection.fields.disclaimer:paragraph2') }}
              </p>
              <p>
                {{ t('inspection.fields.disclaimer:paragraph3') }}
              </p>
            </li>
          </ul>

          <div class="assignee">
            <p>
              <span>{{ t('inspection.fields.general:inspectorName') }}</span
              ><span class="value">{{
                entity.order?.assignee | username
              }}</span>
            </p>
            <p style="margin-right: 100px">
              <span>{{
                t('inspection.fields.general:inspectionDatePerformed')
              }}</span>
              <span class="value">{{ entity.inspectionDate | date }}</span>
            </p>
          </div>
          <p>
            <span>{{
              t('inspection.fields.general:disclaimerSignature')
            }}</span>
            <span class="value signature">
              <img
                *ngIf="!isNew && !printPreview && entity.isSignedDisclaimer"
                [src]="
                  getUserSignatureUrl(entity.order?.assignee)
                    | safe : 'resourceUrl'
                "
              />
            </span>
          </p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #inspectionDesignTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-planner-selector
        [planner]="entity.order?.planner"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionDesign.isApplicable"
        (plannerSelect)="plannerSelected($event)"
      ></authority-labs-planner-selector>
      <authority-labs-plans
        [planningDetails]="entity.inspectionDesign.planningDetails"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionDesign.isApplicable"
        inkSectionKey="design"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-sprinkler-system-design-inspection
        [data]="entity.inspectionDesign.sprinklerSystemDesign"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionDesign.isApplicable"
        (dataChange)="onDataChange()"
      ></authority-labs-sprinkler-system-design-inspection>
      <authority-labs-pump-room-design-inspection
        [data]="entity.inspectionDesign.pumpRoomDesign"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionDesign.isApplicable"
        (dataChange)="onDataChange()"
      ></authority-labs-pump-room-design-inspection>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionDesign?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionDesign.isApplicable"
        [type]="entity.inspectionDesign.title"
        (dataChange)="onSummaryNotesChange($event, entity.inspectionDesign)"
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionInstallationTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-contractor-selector
        [contractor]="entity.order?.contractor"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionInstallation.isApplicable"
        (contractorSelect)="contractorSelected($event)"
      ></authority-labs-contractor-selector>
      <mat-form-field floatLabel="always" appearance="fill">
        <mat-label>{{
          t('inspection.fields.installation:companion')
        }}</mat-label>
        <input
          type="text"
          matInput
          [placeholder]="
            t('inspection.fields.installation:companionPlaceholder')
          "
          [(ngModel)]="entity.inspectionInstallation.companion"
          [readonly]="
            readonly ||
            printPreview ||
            !entity.inspectionInstallation.isApplicable
          "
          (input)="onDataChange()"
        />
        <authority-labs-draft-field-indicator
          matSuffix
          fieldId="installation:companion"
        ></authority-labs-draft-field-indicator>
      </mat-form-field>
      <authority-labs-sprinkler-system-installation-inspection
        [data]="entity.inspectionInstallation.sprinklerSystemInstallation"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionInstallation.isApplicable"
        (dataChange)="onDataChange()"
      >
      </authority-labs-sprinkler-system-installation-inspection>
      <authority-labs-pump-room-installation-inspection
        [data]="entity.inspectionInstallation.pumpRoomInstallation"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionInstallation.isApplicable"
        (dataChange)="onDataChange()"
      >
      </authority-labs-pump-room-installation-inspection>
      <authority-labs-water-network-characterization-inspection
        [waterNetworkData]="
          entity.inspectionInstallation.waterNetworkCharacterization
        "
        [systemFlow]="entity.waterFlowPressure?.flowRate"
        [systemDemand]="entity.waterFlowPressure?.pressure"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionInstallation.isApplicable"
        (dataChange)="onDataChange()"
      >
      </authority-labs-water-network-characterization-inspection>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionInstallation?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionInstallation.isApplicable"
        [type]="entity.inspectionInstallation.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionInstallation)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionWaterNetworkCharacterizationTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-water-network-characterization-inspection
        [waterNetworkData]="entity.inspectionWaterNetworkCharacterization"
        [systemFlow]="entity.waterFlowPressure?.flowRate"
        [systemDemand]="entity.waterFlowPressure?.pressure"
        [printPreview]="printPreview"
        [readonly]="readonly"
        (dataChange)="onDataChange()"
      >
      </authority-labs-water-network-characterization-inspection>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionWaterNetworkCharacterization?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionWaterNetworkCharacterization.isApplicable
        "
        [type]="entity.inspectionWaterNetworkCharacterization.title"
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionWaterNetworkCharacterization
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionGasExtinguishingSystemTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-planner-selector
        [planner]="entity.order?.planner"
        [printPreview]="printPreview"
        [readonly]="
          readonly || !entity.inspectionGasExtinguishingSystem.isApplicable
        "
        (plannerSelect)="plannerSelected($event)"
      ></authority-labs-planner-selector>
      <authority-labs-plans
        [planningDetails]="
          entity.inspectionGasExtinguishingSystem.planningDetails
        "
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="printPreview"
        [readonly]="
          readonly || !entity.inspectionGasExtinguishingSystem.isApplicable
        "
        inkSectionKey="gasExtinguishing"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-gas-extinguishing-system
        [data]="
          entity.inspectionGasExtinguishingSystem.gasExtinguishingSystemDesign
        "
        [printPreview]="printPreview"
        [readonly]="
          readonly || !entity.inspectionGasExtinguishingSystem.isApplicable
        "
        (dataChange)="onDataChange()"
      ></authority-labs-gas-extinguishing-system>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionGasExtinguishingSystem?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="
          readonly || !entity.inspectionGasExtinguishingSystem.isApplicable
        "
        [type]="entity.inspectionGasExtinguishingSystem.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionGasExtinguishingSystem)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionFireTapsTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-fire-taps
        [data]="entity.inspectionFireTaps"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionFireTaps.isApplicable"
        (dataChange)="onDataChange()"
      ></authority-labs-fire-taps>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionFireTaps?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionFireTaps.isApplicable"
        [type]="entity.inspectionFireTaps.title"
        (dataChange)="onSummaryNotesChange($event, entity.inspectionFireTaps)"
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionFireExtinguishersTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-fire-extinguishers
        [data]="entity.inspectionFireExtinguishers"
        [printPreview]="printPreview"
        [readonly]="
          readonly || !entity.inspectionFireExtinguishers.isApplicable
        "
        (dataChange)="onDataChange()"
      ></authority-labs-fire-extinguishers>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionFireExtinguishers?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="
          readonly || !entity.inspectionFireExtinguishers.isApplicable
        "
        [type]="entity.inspectionFireExtinguishers.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionFireExtinguishers)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionAerosolShutdownTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-planner-selector
        [planner]="entity.order?.planner"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionAerosolShutdown.isApplicable"
        (plannerSelect)="plannerSelected($event)"
      ></authority-labs-planner-selector>
      <authority-labs-plans
        [planningDetails]="entity.inspectionAerosolShutdown.planningDetails"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionAerosolShutdown.isApplicable"
        inkSectionKey="aerosolShutdown"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-aerosol-shutdown
        [data]="entity.inspectionAerosolShutdown.aerosolShutdownDesign"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionAerosolShutdown.isApplicable"
        (dataChange)="onDataChange()"
      ></authority-labs-aerosol-shutdown>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionAerosolShutdown?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionAerosolShutdown.isApplicable"
        [type]="entity.inspectionAerosolShutdown.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionAerosolShutdown)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionFireAlarmSystemTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-planner-selector
        [planner]="entity.order?.planner"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionFireAlarmSystem.isApplicable"
        (plannerSelect)="plannerSelected($event)"
      ></authority-labs-planner-selector>
      <authority-labs-plans
        [planningDetails]="entity.inspectionFireAlarmSystem.planningDetails"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionFireAlarmSystem.isApplicable"
        inkSectionKey="fireAlarmSystem"
        (dataChange)="onDataChange()"
      ></authority-labs-plans>
      <authority-labs-fire-alarm-system
        [data]="entity.inspectionFireAlarmSystem.fireAlarmSystemDesign"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionFireAlarmSystem.isApplicable"
        (dataChange)="onDataChange()"
      ></authority-labs-fire-alarm-system>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionFireAlarmSystem?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionFireAlarmSystem.isApplicable"
        [type]="entity.inspectionFireAlarmSystem.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionFireAlarmSystem)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionAirConditioningAndVentilationSystemsTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-air-conditioning-and-ventilation-systems
        [data]="entity.inspectionAirConditioningAndVentilationSystems"
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionAirConditioningAndVentilationSystems.isApplicable
        "
        (dataChange)="onDataChange()"
      ></authority-labs-air-conditioning-and-ventilation-systems>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="
          entity?.inspectionAirConditioningAndVentilationSystems?.summaryNotes
        "
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionAirConditioningAndVentilationSystems.isApplicable
        "
        [type]="entity.inspectionAirConditioningAndVentilationSystems.title"
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionAirConditioningAndVentilationSystems
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionVentilationSystemAndFireProtectionTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-ventilation-system-and-fire-protection-in-commercial-cooking-systems
        [data]="entity.inspectionVentilationSystemAndFireProtection"
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionVentilationSystemAndFireProtection.isApplicable
        "
        (dataChange)="onDataChange()"
      ></authority-labs-ventilation-system-and-fire-protection-in-commercial-cooking-systems>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="
          entity?.inspectionVentilationSystemAndFireProtection?.summaryNotes
        "
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionVentilationSystemAndFireProtection.isApplicable
        "
        [type]="entity.inspectionVentilationSystemAndFireProtection.title"
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionVentilationSystemAndFireProtection
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionPressureSystemInStairwellsCompatibilityCheckTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-pressure-system-in-stairwells-compatibility-check
        [data]="entity.inspectionPressureSystemInStairwellsCompatibilityCheck"
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionPressureSystemInStairwellsCompatibilityCheck
            .isApplicable
        "
        (dataChange)="onDataChange()"
      ></authority-labs-pressure-system-in-stairwells-compatibility-check>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="
          entity?.inspectionPressureSystemInStairwellsCompatibilityCheck
            ?.summaryNotes
        "
        [printPreview]="printPreview"
        [readonly]="
          readonly ||
          !entity.inspectionPressureSystemInStairwellsCompatibilityCheck
            .isApplicable
        "
        [type]="
          entity.inspectionPressureSystemInStairwellsCompatibilityCheck.title
        "
        (dataChange)="
          onSummaryNotesChange(
            $event,
            entity.inspectionPressureSystemInStairwellsCompatibilityCheck
          )
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #inspectionIntegrationTpl>
    <div class="form" cdkScrollable>
      <br />
      <authority-labs-planner-selector
        [planner]="
          entity.inspectionIntegration?.integrationDesign?.safetyConsultant
        "
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionIntegration.isApplicable"
        (plannerSelect)="safetyConsultantSelected($event)"
      ></authority-labs-planner-selector>
      <authority-labs-integration
        [data]="entity.inspectionIntegration"
        [orderDirectory]="entity.order?.sharePoint"
        [orderId]="entity.orderId"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionIntegration.isApplicable"
        (dataChange)="onDataChange()"
      ></authority-labs-integration>
      <h3 class="main-title">{{ t('inspection.sections.generalNotes') }}</h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.inspectionIntegration?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly || !entity.inspectionIntegration.isApplicable"
        [type]="entity.inspectionIntegration.title"
        (dataChange)="
          onSummaryNotesChange($event, entity.inspectionIntegration)
        "
      ></authority-labs-check-summary-notes>
    </div>
  </ng-template>

  <ng-template #summeryTpl>
    <div class="form" cdkScrollable>
      <br />
      <h3 class="main-title">{{ t('inspection.sections.summary') }}</h3>

      <mat-form-field floatLabel="always">
        <mat-label>{{ t('conclusion') }}</mat-label>
        <mat-select
          *ngIf="
            !(
              readonly ||
              printPreview ||
              (!isManager && isKnownInspectionType) ||
              entity.isWaterNetworkCharacterizationInspection
            )
          "
          name="conclusion"
          [(ngModel)]="entity.order.conclusion"
          (selectionChange)="conclusionChanged($event)"
        >
          <mat-option
            *ngFor="let c of conclusions | values | without : [NotApplicable]"
            [value]="c"
          >
            {{ c }}
          </mat-option>
        </mat-select>

        <input
          *ngIf="
            readonly ||
            printPreview ||
            (!isManager && isKnownInspectionType) ||
            entity.isWaterNetworkCharacterizationInspection
          "
          matInput
          class="text"
          name="conclusion"
          [ngModel]="entity.order?.conclusion"
          readonly
        />
      </mat-form-field>

      <br />
      <mat-form-field floatLabel="always">
        <mat-label>{{ t('assignee') }}</mat-label>
        <input
          matInput
          name="assignee"
          [ngModel]="entity.order?.assignee | username"
          readonly
        />
      </mat-form-field>

      <br />
      <mat-form-field floatLabel="always">
        <mat-label>{{ t('approvedBy') }}</mat-label>
        <mat-select
          *ngIf="!(readonly || printPreview)"
          [(ngModel)]="entity.order.approvedBy"
          (selectionChange)="onOrderDetailsChange()"
        >
          <mat-option
            *ngFor="let manager of managers"
            [value]="manager.username"
          >
            {{ manager.displayName }}
          </mat-option>
        </mat-select>

        <input
          *ngIf="readonly || printPreview"
          matInput
          name="approvedBy"
          [ngModel]="entity.order?.approvedBy | username"
          readonly
        />
      </mat-form-field>

      <br />
      <mat-form-field class="order-status" floatLabel="always">
        <mat-label>סטטוס הזמנה</mat-label>
        <mat-select
          *ngIf="!(readonly || printPreview)"
          [(ngModel)]="entity.order.status"
          [compareWith]="compareFn"
          [disabled]="isOrderStatusSelectDisabled"
          (selectionChange)="onOrderDetailsChange()"
        >
          <mat-option
            *ngFor="let status of orderStatusList"
            [disabled]="!canUseStatus(status)"
            [value]="status"
          >
            {{ status.name }}
          </mat-option>
        </mat-select>

        <input
          *ngIf="readonly || printPreview"
          matInput
          name="status"
          [ngModel]="entity.order?.status?.name"
          readonly
        />
      </mat-form-field>

      <h3 class="main-title">
        {{ t('inspection.sections.summaryCertificateNotes') }}
      </h3>
      <authority-labs-check-summary-notes
        [notes]="entity?.summaryNotes"
        [printPreview]="printPreview"
        [readonly]="readonly"
        [type]="entity.inspectionType + '_הערות סיכום לתעודה'"
        (dataChange)="onSummaryNotesChange($event, entity)"
      ></authority-labs-check-summary-notes>
      <br />
      <authority-labs-notes
        *ngIf="!(isNew || printPreview)"
        [entityId]="entity.order?.id"
        [service]="notesService"
      ></authority-labs-notes>
    </div>
  </ng-template>
</ng-container>
